import script from "./TruncatedNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./TruncatedNumber.vue?vue&type=script&setup=true&lang=js"

import "./TruncatedNumber.vue?vue&type=style&index=0&id=78b7a39c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78b7a39c"]])

export default __exports__